<template>
  <div class="full-screen">
    <van-overlay :show="isShowFullScreen" @click="enterFullScreen()">
      <div class="wrapper">
        <div class="header"></div>
        <div class="enter_live">
            <div class="ellca">
                <div class="wZrKdsSD"></div>
                <div class="d9kg8M3o"></div>
            </div>
            <span>点击进入全屏模式</span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GetUtils from "../../utils/utils";
export default {
    name: 'FullScreenPop',
    data() {
        return {
        }
    },
    computed: {
        ...mapState({
            channel: (state) => state.home.channel,
            scSwitch: (state) => state.home.scSwitch,
            directLive: (state) => state.home.directLive,
        }),
        isShowFullScreen() {
            if(this.channel === 'p2' && !GetUtils.isiOS() && this.scSwitch && this.directLive) {
                return true;
            }else {
                return false;
            }
        }
    },
    methods: {
        enterFullScreen() {
            // 唤起全屏直播
            if ((window.AndroidClient && window?.AndroidClient.onFullScreen && window?.AndroidClient.onFullScreenForOneGame) || false) {
                window?.AndroidClient.onFullScreenForOneGame();
                this.$store.commit('SET_SC_SWITCH', false)
            }else {
                if((window.AndroidClient && window?.AndroidClient.onFullScreen) || false) {
                    if(window?.AndroidClient.onCheckLoginStatus) {
                        window?.AndroidClient.onCheckLoginStatus();
                        window?.AndroidClient.onFullScreen();
                        this.$store.commit('SET_SC_SWITCH', false)
                    }else {
                        window?.AndroidClient.onFullScreen();
                        this.$store.commit('SET_SC_SWITCH', false)
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.full-screen {
    .van-overlay {
        z-index: 99;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        position: relative;
        top: -80px;
        .header {
            width: 200px;
            height: 200px;
            background: url('@/assets/images/live_full_sreen.png') no-repeat;
            background-size: 100%;
        }
        .enter_live {
            width: 185px;
            height: 38px;
            border-radius: 50px;
            border: 2px solid #FFF;
            background: rgba(255, 255, 255, 0.18);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 12px 0 12px;
            z-index: 5;
            .ellca{
                height: 24px;
                position: relative;
                width: 24px;
            }
            .wZrKdsSD {
                background-size: 24px;
                font-size: 0;
                height: 24px;
                left: 0;
                position: absolute;
                top: 0;
                width: 24px;
                animation: RZtvbkZS 1s steps(94,start) forwards;
                background-image: url('@/assets/images/play_effect.cf9.png');
            }
            .d9kg8M3o{
                background-size: 24px;
                font-size: 0;
                height: 24px;
                left: 0;
                position: absolute;
                top: 0;
                width: 24px;
                animation: IQSm9z3E 1s steps(95,start) infinite;
                background-image: url('@/assets/images/playing_effect.f3.png');
                opacity: 0;
            }

            @keyframes RZtvbkZS {
                96% {
                    background-position-y: -2256px;
                    opacity: 1
                }
                100% {
                    background-position-y: -2256px;
                    opacity: 0
                }
            }

            @keyframes IQSm9z3E {
                0% {
                    opacity: 1
                }
                100% {
                    background-position-y: -2280px;
                    opacity: 1
                }
            }
            span {
                color: #FFF;
                font-size: 16px;
            }
            }
    }
}
</style>